export default __webpack_public_path__ + "images/5aa9af497c2eac17116bc65d3a9e13c8.png";